import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  updateDeliveryAddress: { isLoading: false },
  updateSenderInfo: { isLoading: false },
  updateMessageOnCard: { isLoading: false },
  /** @type {string|null} Account route slug for in-drawer order modification */
  activeSection: null,
  selectedProductUniqueId: null,
  updateToast: {
    isOpen: false,
    message: "",
    type: "",
  },
};

const orderModificationSlice = createSlice({
  name: "orderModification",
  initialState,
  reducers: {
    setOrderModificationProductId: (state, action) => {
      state.selectedProductUniqueId = action.payload ?? null;
    },
    setOrderModificationActiveSection: (state, action) => {
      state.activeSection = action.payload ?? null;
    },
    clearOrderModificationActiveSection: (state) => {
      state.activeSection = null;
      state.selectedProductUniqueId = null;
    },
    requestToUpdateSenderDetails: (state) => {
      state.updateSenderInfo.isLoading = true;
    },
    responseFromUpdateSenderDetails: (state) => {
      state.updateSenderInfo.isLoading = false;
      state.updateToast = {
        isOpen: true,
        message: "Changes updated successfully.",
        type: "success",
      };
    },
    failedToUpdateSenderDetails: (state) => {
      state.updateSenderInfo.isLoading = false;
      state.updateToast = {
        isOpen: true,
        message: "Changes Not Saved",
        type: "error",
      };
    },
    requestToUpdateRecipientDetails: (state) => {
      state.updateDeliveryAddress.isLoading = true;
    },
    responseFromUpdateRecipientDetails: (state) => {
      state.updateDeliveryAddress.isLoading = false;
      state.updateToast = {
        isOpen: true,
        message: "Changes updated successfully.",
        type: "success",
      };
    },
    failedToUpdateRecipientDetails: (state) => {
      state.updateDeliveryAddress.isLoading = false;
      state.updateToast = {
        isOpen: true,
        message: "Changes Not Saved",
        type: "error",
      };
    },
    requestToUpdateGiftMessages: (state) => {
      state.updateMessageOnCard.isLoading = true;
    },
    responseFromUpdateGiftMessages: (state) => {
      state.updateMessageOnCard.isLoading = false;
      state.updateToast = {
        isOpen: true,
        message: "Changes updated successfully.",
        type: "success",
      };
    },
    failedToUpdateGiftMessages: (state) => {
      state.updateMessageOnCard.isLoading = false;
      state.updateToast = {
        isOpen: true,
        message: "Changes Not Saved",
        type: "error",
      };
    },
    dismissOrderModificationToast: (state) => {
      state.updateToast = { isOpen: false, message: "", type: "" };
    },
  },
});

export const {
  setOrderModificationProductId,
  setOrderModificationActiveSection,
  clearOrderModificationActiveSection,
  requestToUpdateSenderDetails,
  responseFromUpdateSenderDetails,
  failedToUpdateSenderDetails,
  requestToUpdateRecipientDetails,
  responseFromUpdateRecipientDetails,
  failedToUpdateRecipientDetails,
  requestToUpdateGiftMessages,
  responseFromUpdateGiftMessages,
  failedToUpdateGiftMessages,
  dismissOrderModificationToast,
} = orderModificationSlice.actions;

export default orderModificationSlice.reducer;
